// extracted by mini-css-extract-plugin
export default {"paymentGroupBanner":"E7jNh1","container":"lohAZ8","containerUx4":"wdgzZg"};